import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

interface UaActionTile {
  value: string;
  label: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-step-ua-cleanup',
  templateUrl: './step-ua-cleanup.component.html',
  styleUrls: ['./step-ua-cleanup.component.css']
})
export class StepUaCleanupComponent {
  @Input() form!: FormGroup;
  @Input() stepLabel = 'Cleanup';

  readonly actionTiles: UaActionTile[] = [
    {
      value: 'DoNothing',
      label: 'Do Nothing',
      description: 'Subscription and resources remain active.',
      icon: 'block'
    },
    {
      value: 'DeactivateSubscription',
      label: 'Deactivate Subscription',
      description: 'Suspend the Azure subscription to prevent usage.',
      icon: 'pause_circle'
    },
    {
      value: 'DeleteResources',
      label: 'Delete Resources',
      description: 'Remove all resources inside the subscription; subscription stays active.',
      icon: 'delete_sweep'
    },
  ];

  get selectedAction(): string {
    return this.form?.get('actionType')?.value ?? 'DoNothing';
  }

  selectAction(value: string): void {
    this.form.get('actionType')?.setValue(value);
  }
}
